import * as React from "react";

const ZipCodeIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    id="fi_1295181"
    viewBox="0 -1 512 512"
  >
    <path d="M204.5 458.605v51.856l-12.54-10.129c-1.937-1.566-48.034-38.992-94.78-92.66C32.695 333.637 0 267.18 0 210.152V204.5C0 91.738 91.738 0 204.5 0S409 91.738 409 204.5v5.652c0 4.79-.254 9.653-.715 14.575l-39.992-36.485c-8.191-83.156-78.52-148.34-163.793-148.34-90.758 0-164.598 73.84-164.598 164.598v5.652c0 96.368 124.164 213.028 164.598 248.453m122.7-28.66h59.85v-59.851H327.2zM204.5 119.707c46.754 0 84.793 38.04 84.793 84.793s-38.04 84.793-84.793 84.793-84.793-38.04-84.793-84.793 38.04-84.793 84.793-84.793m0 39.902c-24.754 0-44.89 20.137-44.89 44.891 0 24.75 20.136 44.89 44.89 44.89 24.75 0 44.89-20.14 44.89-44.89 0-24.754-20.14-44.89-44.89-44.89m280.61 243.223-11.22-10.234v64.058c0 29.828-24.269 54.094-54.097 54.094H293.461c-29.828 0-54.098-24.266-54.098-54.094v-64.058l-11.218 10.234-26.891-29.477L356.625 231.61 512 373.355zm-51.122-46.637-77.363-70.574-77.36 70.574v100.457c0 7.828 6.368 14.196 14.196 14.196h126.332c7.828 0 14.195-6.368 14.195-14.196zm0 0"></path>
  </svg>
);

export default ZipCodeIcon;
